const getIndicativeFulfilment = ({ indicativeVariantId, variants }) => {
  const { seller = null, source = null } =
    variants.find(({ id }) => id === indicativeVariantId) || {};

  return { seller, source };
};

export default getIndicativeFulfilment;
